// extracted by mini-css-extract-plugin
module.exports = {"people":"People_people__3RVow","wrapper":"People_wrapper__hrZTO","title":"People_title__2ZZtz","cards":"People_cards__1-AkA"};